import { render, staticRenderFns } from "./TextAreaCustomControl.vue?vue&type=template&id=0387bf04&scoped=true&"
import script from "./TextAreaCustomControl.vue?vue&type=script&lang=js&"
export * from "./TextAreaCustomControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387bf04",
  null
  
)

export default component.exports